'use strict';

// recalculate percent of the progress bar to reflect relative size
// to all including competitors
function competizeBacklinks (criteria) {
  var $this = $('#criterium-' + criteria + '.criterium-have-comp:not(.is-competized)');

  if ($this.length === 1) {
    var allProgressBars = $this.find('>div.criterium-content, >div.competitor-content');
    var max = 0;

    var getValue = function ($elem) {
      return parseInt($elem.find('.progressbar .bar .value').data('absValue'), 10);
    };

    $this.addClass('is-competized');

    allProgressBars.each(function () {
      var value = getValue($(this));
      max = Math.max(value, max);
    });

    max *= 1.05;

    return allProgressBars.each(function () {
      var $this = $(this);
      var value = getValue($this);
      var percent = parseInt(value / max * 100, 10);

      $this.find('.progressbar .colored-bar').css('width', percent + '%');

      if (percent < 33) {
        return $this.addClass('low-percent');
      }
    });
  }
  return false;
}

module.exports = competizeBacklinks;
